import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

document.querySelectorAll('.swiper').forEach((swiperEl) => {
    const controls = swiperEl.nextElementSibling;

    const next = controls.querySelector('.btn-next');
    const prev = controls.querySelector('.btn-prev');
    const pagination = controls.querySelector('.swiper-pagination');

    new Swiper(swiperEl, {
        modules: [Autoplay, Navigation, Pagination],

        loop: true,

        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        pagination: {
            el: pagination,
            clickable: true,
        },
    });
});